import Reveal from "../motion/Reveal";
import "./PortfolioPage.css";

export default function PortfolioPage() {
  return (
    <div className="portfolio-page" id="portfolio">
      <main>
        <header className="portfolio-heading">
          <Reveal>
            <p className="section-kicker">
              <span>04</span>
              <span className="section-rule section-rule-long" aria-hidden="true" />
            </p>
          </Reveal>
          <Reveal variant="editorial" delay={1}>
            <h1>Portfolio</h1>
          </Reveal>
        </header>
        <Reveal delay={2}>
          <div className="portfolio-studies">
            <p className="portfolio-soon">
              Good things take thought. Case studies are brewing.
            </p>
          </div>
        </Reveal>
      </main>
    </div>
  );
}
